// A safe stand-in for web/SSR. Optionally map NEXT_PUBLIC_* to keys you expect.
const cfg = {};

// Example: mirror NEXT_PUBLIC_ vars to plain names (optional):
if (typeof process !== 'undefined' && process.env) {
	for (const k of Object.keys(process.env)) {
		if (k.startsWith('NEXT_PUBLIC_')) {
			cfg[k.replace(/^NEXT_PUBLIC_/, '')] = process.env[k];
		}
	}
}

module.exports = cfg;
